if (!String.prototype.startsWith) {
  String.prototype.startsWith = function startsWith(searchString, position) { // eslint-disable-line no-extend-native, max-len
    const p = position || 0
    return this.substr(p, searchString.length) === searchString
  }
}
